<script lang="ts">
export default {
  name: 'CanvasActions',
  components: {
    GridToggle,
    SnapToToggle,
    ExportButton,
    LegendToggle,
    LimitPremiumCounterToggle,
    HelpCircle,
  },
};
</script>

<script setup lang="ts">
import GridToggle from './GridToggle.vue';
import SnapToToggle from './SnapToToggle.vue';
import ExportButton from '@/views/tower/v2/ExportButton.vue';
import LegendToggle from '@/views/tower/v2/LegendToggle.vue';
import LimitPremiumCounterToggle from './LimitPremiumCounterToggle.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { AppState } from '@/store';
import ExportList from '@/views/tower/v2/ExportList.vue';
import { HelpCircle } from '@lucide/vue';

const store = useStore<AppState>();
const isPanelOpen = computed(() => store?.state.towerCanvasState.programsPanelState.show);
</script>

<template>
  <div
    class="row-start-2 col-start-2 col-span-2 justify-self-end flex flex-col justify-end mr-2"
    :class="{ '!col-start-2 mr-96 justify-self-center lg:justify-self-end': isPanelOpen }"
  >
    <ExportList class="mr-2" />
    <div class="flex h-14 gap-1">
      <SnapToToggle />
      <LegendToggle />
      <GridToggle />
      <LimitPremiumCounterToggle />
      <ExportButton />
      <a
        href="https://cobbs-allen.sharefile.com/f/fodf52cc-2817-4922-bf95-8473a458c56a"
        target="_blank"
        title="Help"
        class="pointer-events-auto flex items-center text-sm text-gray-500 font-medium ml-2 cursor-pointer self-center hover:scale-110 transition-all duration-75"
      >
        <HelpCircle
          class="ml-2 self-center transition-all hover:stroke-lime-600"
        />
      </a>
    </div>
  </div>
</template>
